function init() {
	var inputs = document.querySelectorAll(
		".contact-form .field input, .contact-form .field textarea, .newsletter-form .field input, .newsletter-form .field textarea"
	);

	if (inputs.length > 0) {
		window.utils.forEach(inputs, function (index, input) {
			input.addEventListener("focus", function () {
				var field = input.closest(".field");
				field.classList.add("active");
			});
		});
	}
}

export default { init };
